module.exports = __webpack_public_path__ + "share-button-next.21bd3972.png";